export const transformMessages = (data = {}) => {
    const list = data?.DataList || [];

    const transformedList = list.map((MC) => {
        const fullPUName = `${MC?.PULastName || ''} ${MC?.PUFirstName || ''}`.trim();
        const fullIMTName = `${MC?.IMTLastName || ''} ${MC?.IMTFirstName || ''} ${MC?.IMTMiddleName || ''}`.trim();


        let ModeOfPayment = null;
        if (MC?.IsHoldCOD === 1) ModeOfPayment = 'COD';
        else if (MC?.IsDebitInmateFreeCredit === 1) ModeOfPayment = 'Free Credits';
        else if (MC?.IsDebitPUICredit === 1) ModeOfPayment = 'Public User Credits';
        else if (MC?.IsDebitInmateCactasCredit === 1) ModeOfPayment = 'Cactas Credits';

        // IsCODMessage
        const IsCODMessage =
            MC?.DebitAmountDate === MC?.MessageSentDate ? 'NO' : 'YES';

        // CODStatus
        let CODStatus = null;
        if (MC?.DebitAmountDate && MC?.DebitAmountDate !== MC?.MessageSentDate)
            CODStatus = 'APPROVED';
        else if (MC?.IsSenderMsgDelete === 1 && MC?.IsHoldCOD === 1)
            CODStatus = 'REJECTED';
        else if (MC?.IsHoldCOD === 1)
            CODStatus = 'PENDING';
        else if (MC?.DebitAmountDate === MC?.MessageSentDate)
            CODStatus = '-';

        // Time difference
        const isWithin5Sec =
            MC?.DebitAmountDate && MC?.MessageReceiveDate
                ? Math.abs(
                    (new Date(MC.DebitAmountDate) - new Date(MC.MessageReceiveDate)) / 1000
                ) <= 5
                : false;


        // ApproveOrRejectedBy
        let ApproveOrRejectedBy = '-';
        if (MC?.DebitAmountDate === MC?.MessageSentDate) {
            ApproveOrRejectedBy = '-';
        } else if (MC?.IsSenderMsgDelete === 1 && MC?.MessageRejectedBY === 1 && MC?.IsHoldCOD === 1) {
            ApproveOrRejectedBy = MC?.ISMESSAGESENDER === 1 ? MC?.MessageFrom : MC?.MessageTo;
        } else if (MC?.IsSenderMsgDelete === 1 && MC?.MessageRejectedBY === 0 && MC?.IsHoldCOD === 1) {
            ApproveOrRejectedBy = MC?.ISMESSAGESENDER === 0 ? MC?.MessageFrom : MC?.MessageTo;
        } else if (MC?.IsHoldCOD === 1) {
            ApproveOrRejectedBy = '-';
        } else if (isWithin5Sec) {
            ApproveOrRejectedBy = MC?.ISMESSAGESENDER === 0 ? MC?.MessageFrom : MC?.MessageTo;
        } else if (MC?.DebitAmountDate && MC?.DebitAmountDate !== MC?.MessageSentDate) {
            ApproveOrRejectedBy = MC?.ISMESSAGESENDER === 1 ? MC?.MessageFrom : MC?.MessageTo;
        }

        // UserType
        let UserType = null;
        if (MC?.DebitAmountDate === MC?.MessageSentDate) UserType = '-';
        else if (MC?.IsSenderMsgDelete === 1 && MC?.MessageRejectedBY === 1 && MC?.IsHoldCOD === 1)
            UserType = 'PUBLIC USER';
        else if (MC?.IsSenderMsgDelete === 1 && MC?.MessageRejectedBY === 0 && MC?.IsHoldCOD === 1)
            UserType = 'INMATE';
        else if (MC?.IsHoldCOD === 1)
            UserType = '-';
        else if (isWithin5Sec)
            UserType = 'INMATE';
        else if (MC?.DebitAmountDate && MC?.DebitAmountDate !== MC?.MessageSentDate)
            UserType = 'PUBLIC USER';


        // MessageFrom
        // const MessageFrom =
        //     MC?.Sender === 'PublicUser'
        //         ? fullPUName
        //         : MC?.Sender === 'Inmate'
        //             ? fullIMTName
        //             : '';

        // MessageTo
        // const MessageTo =
        //     MC?.Receiver === 'PublicUser'
        //         ? fullPUName
        //         : MC?.Receiver === 'Inmate'
        //             ? fullIMTName
        //             : '';


        let MessageStatus = null;
        if (MC?.MessageFlag === 0 && MC?.IsMsgApprove === 0)
            MessageStatus = 'Pending Message Approval';
        else if (MC?.MessageFlag === 0 && MC?.IsMsgApprove === 2)
            MessageStatus = 'Message Reject';
        else if (MC?.MessageFlag !== 2 && MC?.IsReceiverRead === 1 && MC?.IsHoldCOD === 0)
            MessageStatus = 'Read';
        else if (MC?.MessageFlag !== 2 && MC?.IsReceiverRead === 0 && MC?.IsHoldCOD === 0)
            MessageStatus = 'Unread';
        else if (MC?.MessageFlag !== 2 && MC?.IsHoldCOD === 1)
            MessageStatus = 'C.O.D Pending';
        else if (MC?.MessageFlag === 2 && MC?.IsMsgApprove === 0)
            MessageStatus = 'Pending Quarantine Approval';
        else if (MC?.MessageFlag === 2 && MC?.IsMsgApprove === 2)
            MessageStatus = 'Reject Quarantine';
        else if (MC?.MessageFlag === 2 && MC?.IsMsgApprove === 1 && MC?.IsReceiverRead === 1 && MC?.IsHoldCOD === 0)
            MessageStatus = 'Read';
        else if (MC?.MessageFlag === 2 && MC?.IsMsgApprove === 1 && MC?.IsReceiverRead === 0 && MC?.IsHoldCOD === 0)
            MessageStatus = 'Unread';
        else if (MC?.IsHoldCOD === 1)
            MessageStatus = 'C.O.D Message';

        // Sender
        let Sender = null;
        Sender = MC?.ISMESSAGESENDER == 1 ? 'PublicUser' : 'Inmate'

        // Receiver
        let Receiver = null;
        Receiver = MC?.ISMESSAGESENDER == 1 ? 'Inmate' : 'PublicUser'


        return {
            ...MC,
            Receiver,
            Sender,
            ModeOfPayment,
            IsCODMessage,
            CODStatus,
            ApproveOrRejectedBy,
            UserType,
            //  MessageFrom,
            //  MessageTo,
            MessageStatus,
        };
    });

    return {
        ...data,
        DataList: transformedList,
    };
};